import type { ApiClient } from '@klareospace/pharos-lib-front-utils';
import type { PharosApiResponse } from '@klareospace/pharos-lib-types';

export function createSiteApi(client: ApiClient): {
  countBySpace: (spaceIds: string[]) => Promise<Record<string, number>>;
} {
  return {
    countBySpace: async (spaceIds: string[]): Promise<Record<string, number>> => {
      const response = await client.execute<PharosApiResponse<Record<string, number>>>(() =>
        client.instance.post('/sites/count-by-space', { spaceIds }),
      );
      return response.data ?? {};
    },
  };
}
